module.exports = __webpack_public_path__ + "static/media/cross-circle-icon.b3bba90b.svg";